module.exports = __webpack_public_path__ + "static/media/2.a3f28265.jpg";